async function addEditorialProduct(form, button, cart) {
  if (button.disabled) return false;

  const error = form.querySelector('[data-editorial-error]');
  error.hidden = true;
  error.textContent = '';

  const formData = new FormData(form);
  if (!formData.get('id')) return false;

  button.disabled = true;
  if (cart) {
    formData.append('sections', cart.getSectionsToRender().map((section) => section.id).join(','));
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(form.closest?.('dialog')?.editorialOpener || button);
  }

  try {
    const response = await fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });
    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Could not add this product to your cart.');
    }

    const dialog = form.closest?.('dialog');
    if (dialog) {
      dialog.editorialAdded = true;
      dialog.close();
    }
    if (cart) {
      if (typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'collection-editorial',
          productVariantId: formData.get('id'),
          cartData: data,
        });
      }
      cart.renderContents(data);
    } else {
      window.location.href = routes.cart_url;
    }
    return true;
  } catch (caught) {
    error.textContent = caught.message || 'Could not add this product to your cart.';
    error.hidden = false;
    return false;
  } finally {
    button.disabled = false;
  }
}

function initializeCollectionEditorial(root) {
  if (root.dataset.editorialReady === 'true') return;
  root.dataset.editorialReady = 'true';

  root.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-editorial-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog) {
        dialog.editorialOpener = opener;
        dialog.showModal();
      }
      return;
    }

    const closeButton = event.target.closest('[data-editorial-close]');
    if (closeButton) closeButton.closest('dialog').close();
  });

  root.querySelectorAll('[data-editorial-dialog]').forEach((dialog) => {
    dialog.addEventListener('close', () => {
      if (dialog.editorialAdded) {
        dialog.editorialAdded = false;
      } else {
        dialog.editorialOpener?.focus();
      }
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  root.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-editorial-form]');
    if (!form) return;
    event.preventDefault();
    const button = event.submitter || form.querySelector('[data-editorial-add]');
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    addEditorialProduct(form, button, cart);
  });
}

function initializeCollectionEditorials(scope = document) {
  scope.querySelectorAll('.collection-editorial').forEach(initializeCollectionEditorial);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeCollectionEditorials());
} else {
  initializeCollectionEditorials();
}
document.addEventListener('shopify:section:load', (event) => initializeCollectionEditorials(event.target));
